import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { isModuleDisabledResponse, notifyModuleDisabled } from 'utils/moduleDisabled';

const apiBaseURL = process.env.REACT_APP_API_URL;

const handleHeaders = (authToken) => {
    let headers = {
        'app-version': '1',
        'content-type': 'application/json',
        'device-type': '3',
    };
    if (authToken) {
        const decode = jwt_decode(authToken);
        headers['Authorization'] = 'Bearer ' + authToken;
        headers['platform'] = decode['platform'];
    }
    return headers;
};

// 403 MODULE_DISABLED is not an auth failure: just tell the guard so the current view flips to the disabled page.
const handleModuleDisabled = (error) => {
    if (isModuleDisabledResponse(error)) notifyModuleDisabled(error);
};

export const getData = (path, authToken, auth = null, options = {}) => {
    const headers = handleHeaders(authToken);
    return new Promise(function (resolve, reject) {
        axios({
            method: 'get',
            responseType: 'json',
            url: apiBaseURL + path,
            auth: auth,
            headers: headers,
            ...options,
        })
            .then((res) => {
                return resolve(res);
            })
            .catch((error) => {
                handleModuleDisabled(error);
                return reject(error);
            });
    });
};

export const postData = (path, payload, authToken, auth = null) => {
    const headers = handleHeaders(authToken);
    return new Promise(function (resolve, reject) {
        axios({
            method: 'post',
            responseType: 'json',
            url: apiBaseURL + path,
            data: payload,
            auth: auth,
            headers: headers,
        })
            .then((res) => {
                return resolve(res);
            })
            .catch((error) => {
                handleModuleDisabled(error);
                return reject(error);
            });
    });
};
